import DEFAULTS from '@/defaults.ts'
import { getLoggedInUserAPICall } from '@/store/auth/api/getLoggedInUserAPICall.ts'
import { DefaultRootState } from '@/store/coreReducer.ts'
import { LoginResponseDto } from '@/types/auth.ts'
import { createAsyncThunk } from '@reduxjs/toolkit'

const getLoggedInUser = createAsyncThunk<LoginResponseDto | undefined, boolean, { state: DefaultRootState }>(
	'user/getLoggedInUser',
	async (shouldRedirect: boolean = true) => {
		try {
			return getLoggedInUserAPICall()
				.then(res => {
					return res
				})
				.catch(err => {
					if (shouldRedirect) {
						window.location.href = `${DEFAULTS.LoginURL}/backend/login/redir?redir=${DEFAULTS.BaseURL}`
						throw err
					} else {
						return undefined
					}
				})
		} catch (e) {
			console.log(e)
			throw new Error('access denied')
		}
	},
)

export { getLoggedInUser }
